// extracted by mini-css-extract-plugin
export default {"cls1":"BulkFollowSuggestion-cls1_pZn","cls2":"BulkFollowSuggestion-cls2_Ozu BulkFollowSuggestion-cls1_pZn"};